module.exports = __webpack_public_path__ + "static/media/55_000030.04242b93.jpg";